import util, {getMaxKeyInObject, roundDown32} from "../util";

// frames will now have a primary color attribute so text/menuobj placed over them can be the proper color
export function setPrimaryColor(frame) {
    let frameURL = frame.children('.img').attr('style').match(/"(.*?)"/)[1];
    let img = new Image();
    img.onload = function() {
        let context = getImgContext(img);
        let colors = getColors(context);
        let primaryColor = getMaxKeyInObject(colors);
        frame.attr('primary-color', primaryColor.substring(1, 7));
    }
    img.crossOrigin = "anonymous";
    if (frameURL.includes("https")) {
        return;
    } else {
        img.src = frameURL;
    }

    // https://stackoverflow.com/questions/5162828/how-to-get-the-average-or-main-color-from-an-image-with-javascript
    function getImgContext(img) {
        let canvas = document.createElement("canvas");
        let c = canvas.getContext('2d');
        c.width = canvas.width = img.width;
        c.height = canvas.height = img.height;
        c.clearRect(0, 0, c.width, c.height);
        c.drawImage(img, 0, 0, img.width , img.height);
        return c; // returns the context
    }

    function getColors(c) {
        let col, colors = {};
        let pixels, r, g, b, a;
        r = g = b = a = 0;
        pixels = c.getImageData(0, 0, c.width, c.height);
        for (let i = 0, data = pixels.data; i < data.length; i += 100) {
            r = roundDown32(data[i]);
            g = roundDown32(data[i + 1]);
            b = roundDown32(data[i + 2]);
            a = data[i + 3]; // alpha
            // skip pixels >50% transparent
            if (a < (255 / 2)) continue; 
          
            col = util.rgb2hex('rgb(' + r + ', ' + g + ', ' + b + ')');

            if (!colors[col]) {
                colors[col] = 0;
            }
            colors[col]++;
        }
        return colors;
    }
}
